// 會員路由
const name = '模板'
import Layout from '@/view/layout' // 主框架

export default {
  path: '/wxapp',
  component: Layout,
  children: [
    // 小程式
    {
      path: 'manage/templateedit',
      name: `模板編輯`,
      component: () => import('@/view/wxapp/management')
    },
    {
      path: 'manage/editcategory',
      name: `自定義分類`,
      component: () => import('@/view/wxapp/category')
    },
    {
      path: 'manage/custompage',
      name: `自定義頁面`,
      component: () => import('@/view/wxapp/customPage')
    },
    {
      path: 'manage/floorguide',
      name: `樓層引導`,
      component: () => import('@/view/wxapp/floor_guide')
    },
    {
      path: 'manage/colorstyle',
      name: `風格配色`,
      component: () => import('@/view/wxapp/theme/colorStyle')
    },
    {
      path: 'manage/membercentersetting',
      name: `會員中心設定`,
      component: () => import('@/view/wxapp/memberCenter')
    },
    {
      path: 'manage/wxshopsetting',
      name: `商城資訊`,
      component: () => import('@/view/wxapp/shopInfo')
    },
    // 小程式模板裝修
    // {
    //   path: 'manage/decorate',
    //   name: `模板編輯`,
    //   component: () => import('@/view/decorate/index')
    // },
    // PC商城
    {
      path: 'pcmall/templatelist',
      name: `模板列表`,
      component: () => import('@/view/pc/pctemplate')
    },
    {
      path: 'pcmall/design',
      name: `模板編輯`,
      meta: {
        hidemenu: true
      }
    },
    {
      path: 'pcmall/seo',
      name: `SEO配置`,
      component: () => import('@/view/pc/tdk/globalset')
    },
    {
      path: 'pcmall/pageseo',
      name: `頁面SEO`,
      component: () => import('@/view/pc/tdk/givenset')
    },

    {
      path: 'manage/wxapp',
      name: `模板列表`,
      meta: {
        hidemenu: true
      },
      component: () => import('@/view/wxapp/index'),
      children: [
        {
          path: 'wxapp_templ',
          component: () => import('@/view/wxapp/template')
        }
      ]
    },

    {
      path: 'manage/editauthorize',
      name: `授權設定`,
      component: () => import('@/view/wxapp/authorize/index'),
      children: [
        {
          path: 'policy',
          component: () => import('@/view/wxapp/authorize/policy')
        }
      ]
    },
    {
      path: 'manage/editdashboard',
      name: `資料分析`,
      component: () => import('@/view/wxapp/statistics/dataanalysis/index')
    },
    {
      path: 'manage/editsourcemanagement',
      name: `千人千碼`,
      component: () => import('@/view/wxapp/statistics/sourcemanagement/index'),
      children: [
        {
          path: 'detail/:monitorId?',
          component: () => import('@/view/wxapp/statistics/sourcemanagement/monito_detail')
        }
      ]
    },

    {
      path: 'manage/noticemessage',
      name: `訊息通知`,
      component: () => import('@/view/wxapp/messages')
    },

    {
      path: 'manage/cartremind',
      name: `購物車提醒`,
      component: () => import('@/view/wxapp/cartremind')
    },
    {
      path: 'manage/salespersonshelfindex',
      name: `導購貨架首頁`,
      component: () => import('@/view/wxapp/salespersonshelfindex')
    },
    {
      path: 'aliapp/template',
      name: `模板列表`,
      meta: {
        hidemenu: true
      },
      component: () => import('@/view/wxapp/index'),
      children: [
        {
          path: 'aliapp_templ',
          component: () => import('@/view/wxapp/aliapp/template')
        }
      ]
    },
    {
      path: 'aliapp/templateedit',
      name: `模板編輯`,
      component: () => import('@/view/wxapp/aliapp/management')
    },
    {
      path: 'aliapp/editauthorize',
      name: `授權設定`,
      component: () => import('@/view/wxapp/aliapp/authorize/index')
    },
    {
      path: 'aliapp/editcategory',
      name: `自定義分類`,
      component: () => import('@/view/wxapp/aliapp/category')
    },
    {
      path: 'aliapp/colorstyle',
      name: `風格配色`,
      component: () => import('@/view/wxapp/aliapp/color_style')
    }
    // {
    //   path: 'aliapp/membercentersetting',
    //   name: `會員中心設定`,
    //   component: () => import('@/view/wxapp/aliapp/member_center_setting')
    // }
  ]
}
